import React from "react";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import logo from "../../assets/logo.jpg";
import { Link } from "react-router-dom";
import Copyright from "../../components/copyright";
import brandStore from "../../stores/brandStore";

const SignUp = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const BrandStore = brandStore();

  return (
    <Grid
      container
      component="main"
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "#F9F1F0",
        alignItems: "center",
      }}
    >
      <Container
        component="main"
        maxWidth="sm"
        sx={{ mt: isNonMobile ? 0 : 5, mb: isNonMobile ? 0 : 5 }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            verticalAlign: "center",
            backgroundColor: "#fff",
            borderRadius: "10px",
            p: "20px",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              fontFamily: "Dancing Script",
            }}
          >
            <Avatar
              sx={{
                m: 1,
                bgcolor: "secondary.main",
                height: "50px",
                width: "50px",
                boxShadow: "0 1px 2px var(--babyBlue)",
              }}
            >
              <Box
                component="img"
                src={
                  BrandStore.brand.brandLogo ? BrandStore.brand.brandLogo : logo
                }
                sx={{ objectFit: "cover" }}
                width="100%"
                height="100%"
              />
            </Avatar>{" "}
            {BrandStore.brand.brandName}
          </Typography>

          <Typography
            component="h1"
            variant="h5"
            sx={{ fontFamily: "Ysabeau Office" }}
          >
            Sign Up
          </Typography>
          <Box component="form" noValidate sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="firstName"
                  name="firstName"
                  type="text"
                  required
                  fullWidth
                  label="First Name"
                  autoComplete="given-name"
                  autoFocus
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="lastName"
                  name="lastName"
                  type="text"
                  required
                  fullWidth
                  label="Last Name"
                  autoComplete="family-name"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="email"
                  name="email"
                  type="email"
                  required
                  fullWidth
                  label="Email Address"
                  autoComplete="email"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="password"
                  name="password"
                  type="password"
                  required
                  fullWidth
                  label="Password"
                  autoComplete="new-password"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox value="allowExtraEmails" color="primary" />
                  }
                  label="I want to receive inspiration, marketing promotions and updates via email."
                />
              </Grid>
            </Grid>
            <Button
              type="button"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign Up
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link to="/sign-in">
                  <Typography
                    variant="body2"
                    sx={{ fontFamily: "Ysabeau Office", fontSize: "15px" }}
                  >
                    Already Have an account? Sign In
                  </Typography>
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright
          sx={{ mt: 5, fontFamily: "Ysabeau Office", fontWeight: 700 }}
        />
      </Container>
    </Grid>
  );
};

export default SignUp;
